import {
  FETCH_USER_SEARCH_LIST,
  FETCH_USER_DETAILS,
  UPDATE_USER_DETAILS,
  UPDATE_USER_ROLES,
  UPDATE_USER_ODIN_PERMISSIONS,
  RESET_PERMISSION_STATE,
} from './permissions.actions';
import { SUCCESS, FAILURE, REQUEST } from 'utils/actionGenerator';

const defaultState = {
  userSearchList: null,
  userDetails: {},
  updatedUserCode: null,
  updatedPermissions: false,
};

export default function (state = defaultState, action: any) {
  switch (action?.type) {
    case FETCH_USER_SEARCH_LIST[REQUEST]: {
      return {
        ...state,
        userSearchList: null,
      };
    }
    case FETCH_USER_SEARCH_LIST[SUCCESS]: {
      return {
        ...state,
        userSearchList: action.response.data.user,
      };
    }
    case FETCH_USER_SEARCH_LIST[FAILURE]: {
      return {
        ...state,
        userSearchList: null,
      };
    }

    case FETCH_USER_DETAILS[REQUEST]: {
      return {
        ...state,
        userDetails: {},
      };
    }
    case FETCH_USER_DETAILS[SUCCESS]: {
      return {
        ...state,
        userDetails: action.response.data,
      };
    }
    case FETCH_USER_DETAILS[FAILURE]: {
      return {
        ...state,
        userDetails: {},
      };
    }

    case UPDATE_USER_DETAILS[REQUEST]: {
      return {
        ...state,
        updatedUserCode: null,
      };
    }
    case UPDATE_USER_DETAILS[SUCCESS]: {
      return {
        ...state,
        updatedUserCode: action?.response?.data?.code,
      };
    }
    case UPDATE_USER_DETAILS[FAILURE]: {
      return {
        ...state,
        updatedUserCode: null,
      };
    }

    case UPDATE_USER_ROLES[REQUEST]: {
      return {
        ...state,
      };
    }
    case UPDATE_USER_ROLES[SUCCESS]: {
      return {
        ...state,
        userDetails: { ...state.userDetails, roles: action.response.data.roleDTOs },
      };
    }
    case UPDATE_USER_ROLES[FAILURE]: {
      return {
        ...state,
      };
    }
    case UPDATE_USER_ODIN_PERMISSIONS[REQUEST]: {
      return {
        ...state,
        updatedPermissions: false,
      };
    }
    case UPDATE_USER_ODIN_PERMISSIONS[SUCCESS]: {
      return {
        ...state,
        updatedPermissions: true,
      };
    }
    case UPDATE_USER_ODIN_PERMISSIONS[FAILURE]: {
      return {
        ...state,
        updatedPermissions: false,
      };
    }
    case RESET_PERMISSION_STATE[REQUEST]:
      return {
        ...state,
        updatedPermissions: false,
      };
    default:
      return {
        ...state,
      };
  }
}
